import { render, staticRenderFns } from "./SelectOptionView.vue?vue&type=template&id=47f43862&scoped=true"
import script from "./SelectOptionView.vue?vue&type=script&lang=js"
export * from "./SelectOptionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f43862",
  null
  
)

export default component.exports